export const rows = [
  {
    id: 1,
    displayName: "Johan",
    firstName: "Johan",
    lastName: "Doe",
    roles: "ABC",
    email: "johan@gmail.com",
    active: "yes",
    phoneNumber: "+9265058899879",
    extension: "TEST",
    mobileNumber: "+9265058899879",
  },
  {
    id: 2,
    displayName: "Johan",
    firstName: "Johan",
    lastName: "Doe",
    roles: "ABC",
    email: "johan@gmail.com",
    active: "yes",
    phoneNumber: "+9265058899879",
    extension: "TEST",
    mobileNumber: "+9265058899879",
  },
];
